import {
  treatmentStatusChain,
  type TreatmentStartState,
} from "@care-by-ella/contracts";

// TES-1291 (TES-1267 §4) — the read-only status chain at the top of the
// decision workspace: Emelie's five steps, which are done and which one the
// patient is at. Read from stored facts only (treatmentStatusChain); it
// decides nothing and offers no action.
export function TreatmentStatusChain({
  startState,
  plannedMedication,
}: {
  startState: TreatmentStartState | null | undefined;
  plannedMedication: boolean;
}) {
  const steps = treatmentStatusChain({ startState, plannedMedication });
  return (
    <ol
      aria-label="Statuskedja"
      data-testid="treatment-status-chain"
      className="flex flex-wrap gap-xs text-xs"
    >
      {steps.map((s, i) => (
        <li
          key={s.step}
          aria-current={s.status === "current" ? "step" : undefined}
          data-status={s.status}
          className={`flex items-center gap-xs rounded-full border px-sm py-[2px] ${
            s.status === "done"
              ? "border-brand/40 bg-brand/10 text-textPrimary"
              : s.status === "current"
                ? "border-brand bg-brand-accent font-semibold text-textPrimary"
                : "border-surfaceMuted text-textSecondary"
          }`}
        >
          <span aria-hidden="true">
            {s.status === "done" ? "✓" : `${i + 1}`}
          </span>
          <span>{s.label}</span>
          {s.status === "done" ? (
            <span className="sr-only">(klart)</span>
          ) : s.status === "current" ? (
            <span className="sr-only">(aktuellt steg)</span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
